
import React from 'react';
import { Clock } from 'lucide-react';

interface TimestampDisplayProps {
    timestamp: number | string; // Unix timestamp or ISO string
    label?: string;
    showIcon?: boolean;
}

export const TimestampDisplay: React.FC<TimestampDisplayProps> = ({
    timestamp,
    label,
    showIcon = true
}) => {
    const dateObj = typeof timestamp === 'number'
        ? new Date(timestamp * 1000)
        : new Date(timestamp);

    // Check for invalid date
    if (isNaN(dateObj.getTime())) {
        return <span className="text-muted-foreground text-sm">Invalid Date</span>;
    }

    const isoString = dateObj.toISOString();
    const localString = dateObj.toLocaleString();

    // Basic relative time calculation
    const getRelativeTime = (date: Date) => {
        const diff = Date.now() - date.getTime();
        const seconds = Math.floor(diff / 1000);

        if (seconds < 60) return 'Just now';
        if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
        if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
        return `${Math.floor(seconds / 86400)}d ago`;
    };

    return (
        <div className="flex items-center gap-2 text-sm" title={isoString}>
            {showIcon && <Clock className="h-4 w-4 text-muted-foreground" />}
            {label && <span className="text-muted-foreground">{label}:</span>}
            <span className="font-mono">{localString}</span>
            <span className="text-muted-foreground text-xs">({getRelativeTime(dateObj)})</span>
        </div>
    );
};
